import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLaunchDarkly } from '../../launchdarkly';
import { PlanV2 } from './PlanV2';
import { PlanLegacy } from './PlanLegacy';
import { LoadingProgress } from '../../layout';
import { fromOrder, fromSubscription, useAppDispatch } from '../../store';
import { useQuery } from '../../routes';
import { Feature } from '../../models';

export const Plan = () => {
  const { flags, initialized } = useLaunchDarkly();
  const { get } = useQuery();
  const accountId = Number(get('accountId'));
  const dispatch = useAppDispatch();
  const subscriptionLoading = useSelector(fromSubscription.selectLoading);
  const subscriptions = useSelector(fromSubscription.selectByAccountId(accountId));
  const hasPaidSubscription = useSelector(fromSubscription.hasPaidSubscription(accountId));

  const hasTrueSubscription = subscriptions.some(
    it => it.feature === Feature.TRUE_TEAM || it.feature === Feature.TRUE_ENTERPRISE,
  );

  useEffect(() => {
    dispatch(fromOrder.resetOrderPreviewResponse());
  }, []);

  if (!initialized || subscriptionLoading) {
    return <LoadingProgress fullscreen />;
  }

  if ((flags?.truePlatformEnabled && !hasPaidSubscription) || hasTrueSubscription) {
    return <PlanV2 />;
  }

  return <PlanLegacy />;
};
